import { WidgetHolderComponent } from './widgets/core/widgetholder.component';
import { WidgetsHostDirective } from './widgets/core/widgetshost.component';
import { Component, ViewChild, ComponentFactoryResolver, ViewContainerRef, ComponentFactory, AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { WidgetRowComponent } from './widgets/core/widgetrow.component';
import { SolarComponent } from './widgets/solar/solar.component';
import { WidgetComponent, WidgetParameter } from './widgets/core/widget.component';
import { ChartWidgetTinyComponent } from './widgets/charts/chartwidgettiny.component';
import { ContactsComponent } from './widgets/contacts/contacts.component';
import { ElectricityComponent } from './widgets/electricity/electricity.component';
import { Type } from '@angular/compiler/src/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportsDashboardViewModel, ReportsDashboardWidgetViewModel } from '../@apiClient/core';
import { TableComponent } from './widgets/table/table.component';
import { CustomizedViewService } from '../documents/customizedview.service';
import { DashboardDataService } from './dashboard-data.service';
import { DownloadReportWidgetComponent } from './widgets/downloadreport/downloadreport.component';
import { ImagesCarouselWidgetComponent } from './widgets/images-carousel-widget/images-carousel-widget.component';
import { TitleService } from '../@core/data/title.service';

@Component({
  selector: 'app-dashboard',
  styleUrls: ['./dashboard.component.scss'],
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements AfterViewInit {
  @ViewChild(WidgetsHostDirective, { static: true }) widgetsHost: WidgetsHostDirective;
  entityLoaded: boolean = false;
  existRegions: boolean = false;
  projectGuid: string = '';
  region: string = '';
  regions: any = [];
  existsAvaiableParameters: boolean = false;
  date: any = null;
  projectGuids: any = {};
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private componentFactoryResolver: ComponentFactoryResolver,
    private dashboardDataService: DashboardDataService,
    private customizedViewService: CustomizedViewService,
    private titleService: TitleService) {
    this.widgetRowComponentFactory = this.componentFactoryResolver.resolveComponentFactory(WidgetRowComponent);
    this.widgetHolderComponentFactory = this.componentFactoryResolver.resolveComponentFactory(WidgetHolderComponent);
  }
  private dashboardShortName: string;
  private widgetsHostViewRef: ViewContainerRef;
  private widgetRowComponentFactory: ComponentFactory<WidgetRowComponent>;
  private widgetHolderComponentFactory: ComponentFactory<WidgetHolderComponent>;
  private components: Array<WidgetComponent>;

  ngOnInit() {
    this.components = [];
    this.widgetsHostViewRef = this.widgetsHost.viewContainerRef;
    this.route.params.subscribe(params => {
      this.dashboardShortName = params['dashboardShortName'] || 'home';
      this.loadDashboard(this.dashboardShortName);
    });
    this.dashboardDataService.onfetch.subscribe((dashboards: Array<ReportsDashboardViewModel>) => {
      dashboards.forEach(d => d.shortName == this.dashboardShortName && this.renderDashboard(d));
      this.entityLoaded = true;
    });
  }
  ngAfterViewInit(): void {
    this.components.forEach(c => c.ngAfterViewInit());
  }
  private renderDashboard(dashboard: ReportsDashboardViewModel) {
    this.titleService.append({title:dashboard.name});
    this.widgetsHostViewRef.clear();
    this.components = [];
    let widgetRows: Array<Array<ReportsDashboardWidgetViewModel>> = [];
    dashboard.widgets.forEach(w => {
      let rowNum = w.positionRow - 1;
      if (!widgetRows[rowNum]) widgetRows[rowNum] = [];
      widgetRows[rowNum].push(w);
      this.existsAvaiableParameters = false;
      if (this.projectGuids && !this.projectGuids.values) {
        if (w.availableParameters && w.availableParameters.length > 0) {
          this.projectGuids = w.availableParameters.find(x => x.variables == "project_guid")
          this.existsAvaiableParameters = true
          if (w.availableParameters.find(x => x.variables == "region")) {
            this.existRegions = true
            this.regions = w.availableParameters.find(x => x.variables == "region")
          }
          else {
            this.existRegions = false
          }
        }
      }
    })

    widgetRows.forEach(widgetRow => {
      const widgetRowComponent = this.addWidgetRowComponent();

      widgetRow.forEach(widget => {

        const widgetColSize = widget.sizeCol || 1;
        let widgetCssClass = 'col-xxxl-3 col-md-6';
        switch (widgetColSize) {
          case 1:
            widgetCssClass = 'col-xxxl-4 col-md-4';
            break;
          case 2:
            widgetCssClass = 'col-xxxl-3 col-md-6';
            break;
          case 3:
            widgetCssClass = 'col-xxxl-12 col-xxl-12 col-lg-12 col-md-12';
            break;
        }
        let widgetType: Type = null;
        let widgetComponent: any = null;
        let widgetComponentFactory: ComponentFactory<WidgetComponent>
        switch (widget.widgetKind) {
          case 1:
            widgetType = SolarComponent;
            widgetComponentFactory = this.componentFactoryResolver.resolveComponentFactory<WidgetComponent>(widgetType);
            widgetComponent = this.addWidgetComponent(widgetRowComponent, widgetComponentFactory, widgetCssClass, widget) as SolarComponent;
            widgetComponent.title = widget.title;
            widgetComponent.infoFirstLine = widget.data[0].value;
            widgetComponent.infoSecondLine = widget.data[0].label2;
            widgetComponent.color = widget.data[0].style.class;
            break;
          case 3:
            widgetType = ChartWidgetTinyComponent;
            widgetComponentFactory = this.componentFactoryResolver.resolveComponentFactory<WidgetComponent>(widgetType);
            widgetComponent = this.addWidgetComponent(widgetRowComponent, widgetComponentFactory, widgetCssClass, widget) as ChartWidgetTinyComponent;
            widgetComponent.title = widget.title;
            widgetComponent.value = widget.data;

            break;
          case 2:
            widgetType = SolarComponent;
            widgetComponentFactory = this.componentFactoryResolver.resolveComponentFactory<WidgetComponent>(widgetType);
            widgetComponent = this.addWidgetComponent(widgetRowComponent, widgetComponentFactory, widgetCssClass, widget) as SolarComponent;
            widgetComponent.title = widget.title;
            widgetComponent.infoFirstLine = widget.data[0].label;
            if (!!widget.data[0].label2) {
              widgetComponent.infoSecondLine = widget.data[0].label2;
            }
            if (!!widget.data[0].style) {
              widgetComponent.color = widget.data[0].style.class;
            }
            widgetComponent.chartValue = widget.data[0].value;
            break;
          case 7:
            widgetType = TableComponent;
            widgetComponentFactory = this.componentFactoryResolver.resolveComponentFactory<WidgetComponent>(widgetType);
            widgetComponent = <TableComponent>this.addWidgetComponent(widgetRowComponent, widgetComponentFactory, widgetCssClass, widget);

            break;
          case 6:
            widgetType = ElectricityComponent;
            widgetComponentFactory = this.componentFactoryResolver.resolveComponentFactory<WidgetComponent>(widgetType);
            widgetComponent = this.addWidgetComponent(widgetRowComponent, widgetComponentFactory, widgetCssClass, widget);
            break;
          case 8:
            widgetType = DownloadReportWidgetComponent;
            widgetComponentFactory = this.componentFactoryResolver.resolveComponentFactory<WidgetComponent>(widgetType);
            widgetComponent = this.addWidgetComponent(widgetRowComponent, widgetComponentFactory, widgetCssClass, widget);
            break;
          case 10:
            widgetType = ImagesCarouselWidgetComponent;
            widgetComponentFactory = this.componentFactoryResolver.resolveComponentFactory<WidgetComponent>(widgetType);
            widgetComponent = this.addWidgetComponent(widgetRowComponent, widgetComponentFactory, widgetCssClass, widget);
            break;
          default:
            this.customizedViewService.getWidget(widget.widgetKind, widget.moduleName).then(widgetType => {
              if (!!widgetType) widgetComponent = this.addWidgetComponent(widgetRowComponent, widgetType, widgetCssClass, widget);
            });

        }

      });

    });
  }

  public loadDashboard(dashboardShortName: string) {
    this.dashboardDataService.getDashboard(dashboardShortName); // TODO!: it should load just one dashboard = this.dashboardDataService.getDashboard(dashboardShortName);
  }

  private addWidgetRowComponent(): WidgetRowComponent {
    const widgetRowRef = this.widgetsHostViewRef.createComponent(this.widgetRowComponentFactory);
    return widgetRowRef.instance as WidgetRowComponent;
  }
  private addWidgetComponent(widgetRowComponent: WidgetRowComponent, widgetComponentFactory: ComponentFactory<WidgetComponent>, classList: string, widget: ReportsDashboardWidgetViewModel): WidgetComponent {
    const viewContainerRef = widgetRowComponent.widgetsHost.viewContainerRef;

    const widgetHolderRef = viewContainerRef.createComponent(this.widgetHolderComponentFactory);
    widgetHolderRef.instance.classList = classList;
    const widgetHolderViewRef = widgetHolderRef.instance.widgetsHost.viewContainerRef;
    const widgetComponent = widgetHolderViewRef.createComponent(widgetComponentFactory);
    widgetComponent.instance.seriesCount = widget.seriesCount;
    widgetComponent.instance.series = widget.series;
    widgetComponent.instance.data = widget.data;
    widgetComponent.instance.dataColumns = widget.dataColumns;
    widgetComponent.instance.title = widget.title;
    widgetComponent.instance.legend = widget.legend;
    widgetComponent.instance.description = widget.description;
    widgetComponent.instance.name = widget.guid;
    widgetComponent.instance.availableParameters = WidgetParameter.fromViewModel(widget.availableParameters);
    this.passParametersToWidget(widgetComponent.instance);
    widgetComponent.instance.ngAfterViewInit();
    widgetComponent.instance.reloadAndRedraw();
    this.components.push(widgetComponent.instance);
    return widgetComponent.instance;

  }
  reloadAndRedraw() {
    this.components.forEach(widget => {
      widget.parameters = {};
      if (widget.availableParameters && widget.availableParameters.length > 0) {
        this.passParametersToWidget(widget);
        widget.reloadAndRedraw();
      }
      else {
        widget.reloadAndRedraw();
      }
    });
  }
  private passParametersToWidget(element: WidgetComponent) {
    if (this.projectGuid) {
      element.parameters.project_guid = this.projectGuid;
    }
    if (this.region) {
      element.parameters.region = this.region;
    }
    if (this.date && this.date[0] && this.date[1]) {
      element.parameters.dateBegin = this.date[0].toISOString();
      element.parameters.dateEnd = this.date[1].toISOString();
    }
  }

  refreshAndRedraw() {
    this.projectGuid = null;
    this.region = null;
    this.date = null;
    this.components.forEach(element => {
      element.parameters = {};
      element.refreshAndRedraw();
    });
  }
}
